import { Outlet } from "react-router-dom";
import { useRef } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Map } from "../../components/Organismos/Map";

export const MapPage = () => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Flex h="100%" position="relative" zIndex={0}>
      <Map>
        <Outlet />
      </Map>
      <Box ref={ref}></Box>
    </Flex>
  );
};
